import * as React from 'react'
import Stack from '@mui/material/Stack'
import { currencyString } from '@sales-center/common'
import Typography from '@mui/material/Typography'

type Props = {
  totalValue: number
}

export function TotalValue(props: Props) {
  const { totalValue } = props
  return (
    <Stack direction="column" sx={{ alignItems: 'flex-end' }}>
      <Typography variant="subtitle2">Total Value</Typography>
      <Typography variant="h7">${currencyString(totalValue)}</Typography>
    </Stack>
  )
}
